export const dummyGetter = state => {
    return 'Hello world!';
};



// WEBPACK FOOTER //
// ./src/store/getters.js